export const GET_ALL_EQUIPMENT = 'equipment/GET_ALL_EQUIPMENT';
export const GET_ALL_EQUIPMENT_SUCCESS = 'equipment/GET_ALL_EQUIPMENT_SUCCESS';
export const GET_ALL_EQUIPMENT_ERROR = 'equipment/GET_ALL_EQUIPMENT_ERROR';

export const GET_EQUIPMENT_TYPES = 'equipment/GET_EQUIPMENT_TYPES';
export const GET_EQUIPMENT_TYPES_SUCCESS =
  'equipment/GET_EQUIPMENT_TYPES_SUCCESS';
export const GET_EQUIPMENT_TYPES_ERROR = 'equipment/GET_EQUIPMENT_TYPES_ERROR';

export const GET_EQUIPMENT_BRANDS = 'equipment/GET_EQUIPMENT_BRANDS';
export const GET_EQUIPMENT_BRANDS_SUCCESS =
  'equipment/GET_EQUIPMENT_BRANDS_SUCCESS';
export const GET_EQUIPMENT_BRANDS_ERROR =
  'equipment/GET_EQUIPMENT_BRANDS_ERROR';

export const CREATE_EQUIPMENT = 'equipment/CREATE_EQUIPMENT';
export const CREATE_EQUIPMENT_SUCCESS = 'equipment/CREATE_EQUIPMENT_SUCCESS';
export const CREATE_EQUIPMENT_ERROR = 'equipment/CREATE_EQUIPMENT_ERROR';
